<script setup lang="ts">
import type { HTMLAttributes } from 'vue'

import DialogLoadingOverlay from '@/components/DialogLoadingOverlay.vue'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogScrollContent,
  DialogTitle,
} from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

defineOptions({ inheritAttrs: false })

const props = withDefaults(defineProps<{
  title: string
  description?: string
  class?: HTMLAttributes['class']
  scrollable?: boolean
  loading?: boolean
  loadingMessage?: string
  hideClose?: boolean
  preventClose?: boolean
}>(), {
  loadingMessage: 'Loading…',
})

const open = defineModel<boolean>('open', { required: true })

function handleOpenChange(val: boolean) {
  if ((props.loading || props.preventClose) && !val) return
  open.value = val
}
</script>

<template>
  <Dialog :open="open" @update:open="handleOpenChange">
    <component
      :is="scrollable ? DialogScrollContent : DialogContent"
      v-bind="$attrs"
      :class="cn('sm:max-w-sm', hideClose && '[&>button.absolute.top-4.right-4]:hidden', props.class)"
    >
      <DialogLoadingOverlay v-if="loading" :show="loading" :message="loadingMessage" />
      <DialogHeader>
        <DialogTitle>{{ title }}</DialogTitle>
        <DialogDescription v-if="description">{{ description }}</DialogDescription>
      </DialogHeader>
      <slot />
      <DialogFooter v-if="$slots.footer">
        <slot name="footer" />
      </DialogFooter>
    </component>
  </Dialog>
</template>
